/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable no-cond-assign */
/* eslint-disable multiline-ternary */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import { convertToSlug } from 'src/utils/IdGenerator'
import Image from 'next/image'
import { truncateToTwoWords } from '@utils/utils'
import { AckoMainTheme } from '@acko-tech/building-blocks.ui.theme'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { segmentEventCommonPropFunc } from '@utils/segmentProperties'
import assetLoader from '@utils/internalImageLoader'
import styles from './quick-link2.module.scss'

type QuickLinkListProps = {
  isToggle: boolean
  showDropdown: boolean
  setShowDropdown: (showDropdown: boolean) => void
  isSticky: boolean
  quickLinkLabels?: string[]
  activeSectionId: string | null
  setIsToggle: (isToggle: boolean) => void
  setSelectedListItem: (selectedListItem: string) => void
  segmentEventCommonProperties: any
  windowWidth: number
}

const QuickLinkList = ({
  isToggle,
  showDropdown,
  setShowDropdown,
  isSticky,
  quickLinkLabels = [],
  activeSectionId,
  setIsToggle,
  setSelectedListItem,
  segmentEventCommonProperties,
  windowWidth,
}: QuickLinkListProps) => {
  // Function to render list items
  const renderListItems = (contentSlice: string[], trupleValue: boolean) =>
    contentSlice.map((h2, index) => (
      <li
        key={index}
        className={`${styles.liLink}  ${isSticky && activeSectionId === convertToSlug(h2) ? styles.selectedLi : ''}`}
        onClick={() => {
          ;(async () => {
            const properties = await segmentEventCommonPropFunc(segmentEventCommonProperties)
            trackEvent('tap_btn_engage', {
              ...properties,
              funnel: 'engage',
            })
          })()

          // Handle click on list item
          // setActiveSectionId(convertToSlug(h2))
          setShowDropdown(false)
          setIsToggle(false)
          setSelectedListItem(h2)

          const element: any = document.querySelector(`#${convertToSlug(h2)}`)
          if (element) {
            // Scroll to the corresponding section smoothly
            if (isSticky) {
              window.scrollTo({ behavior: 'smooth', top: element?.offsetTop - 60 })
            } else {
              const quickLInk: any = document.getElementById('quickLinksSection')
              window.scrollTo({ behavior: 'smooth', top: element?.offsetTop - (quickLInk.offsetHeight + 40) })
            }
          }
        }}>
        {/* Link to the section */}
        <Image
          src={`${assetLoader()}/images/quick-links-icon/link.svg`}
          className={styles.linkSvg}
          alt="link svg"
          loading="lazy"
          decoding="async"
          width={20}
          height={20}
        />

        {windowWidth > 768 && windowWidth <= 1070 && trupleValue && isSticky ? (
          <span>{truncateToTwoWords(h2)}</span>
        ) : (
          <span>{h2}</span>
        )}
      </li>
    ))

  return (
    <div className={`${styles.ulBox} ${isToggle ? styles.show : ''} ${showDropdown ? styles.showDropdown : ''}`}>
      {/* First list */}
      {/* <ul>{renderListItems(quickLinkLabels.slice(0, 4), false)}</ul> */}

      {windowWidth > AckoMainTheme?.breakpoints?.m && windowWidth <= AckoMainTheme?.breakpoints?.l && isSticky ? (
        <ul>{renderListItems(quickLinkLabels.slice(0, 3), true)}</ul>
      ) : (
        <ul>{renderListItems(quickLinkLabels.slice(0, 4), false)}</ul>
      )}

      {/* Second list (dropdown) */}
      {windowWidth > AckoMainTheme?.breakpoints?.m && windowWidth <= AckoMainTheme?.breakpoints?.l && isSticky ? (
        <ul className={`${styles.absolute} ${isToggle ? '' : styles.hidden}`}>
          {renderListItems(quickLinkLabels.slice(3), false)}
        </ul>
      ) : (
        <ul className={`${styles.absolute} ${isToggle ? '' : styles.hidden}`}>
          {renderListItems(quickLinkLabels.slice(4), false)}
        </ul>
      )}
      {/* <ul className={`${styles.absolute} ${isToggle ? '' : styles.hidden}`}>
        {renderListItems(quickLinkLabels.slice(4), false)}
      </ul> */}
    </div>
  )
}

export default QuickLinkList
